import { useTranslation } from 'react-i18next';

/**
 * Hook to detect RTL (right-to-left) text direction based on current i18n language.
 */
export const useIsRtl = (): boolean => {
  const { i18n } = useTranslation();
  return i18n?.dir?.() === 'rtl';
};
